import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import ITask from '../../models/task';
import ITaskCriteria from '../../models/task-criteria';
import { TaskService } from '../../services/task-service';
import TaskItemStore from './task-item';
import Subjects from '../../models/subjects';
import Pagination from '../../models/pagination';

export default class TaskListStore {

    data: TaskItemStore[];
    page: number;
    pageSize: number;
    totalCount: number;
    criteria: ITaskCriteria;
    subject: Subjects;
    mathTaskService: TaskService;

    constructor(subject: Subjects) {
        this.data = [];
        this.page = 1;
        this.pageSize = Pagination.PAGE_SIZE;
        this.totalCount = 0;
        this.criteria = {} as ITaskCriteria;
        this.mathTaskService = new TaskService();
        this.subject = subject;
        makeAutoObservable(this);
    }

    initTask(): void {
        this.filterTask(this.criteria, this.page, this.pageSize);
    }

    filterTask(criteria: ITaskCriteria, page: number, pageSize: number): void {

        console.log(`Criteria for search: ${JSON.stringify(criteria)}`);

        try {
            var params = {
                ...criteria,
                page: (page-1),//antd starts pagination from 1, Spring from 0
                size: pageSize
            };
            const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

            this.mathTaskService.search(this.subject, urlParams).then(
                data => {
                    const tasks = data['content'] as ITask[];    
                    this.data = tasks.map(t => new TaskItemStore(t, this.subject));
                    this.page = page;
                    this.pageSize = pageSize;
                    this.totalCount = data['totalElements'];
                }, 
                error => message.error(error)
            );

        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }

    deleteTask(taskId: number) {
        try {
            this.mathTaskService.delete(taskId).then(
                (response) => {

                    if (response.ok) {
                        this.filterTask(this.criteria, this.page, this.pageSize);
                    } else {
                        response.json().then(error => message.error(error['detail']));
                    }
                }
            );
        } catch (error) {
            runInAction(() => { 
                message.error(`Ошибка при удалении задачи: ${error}`);
            });
        }   
    }
}